import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import BootstrapTable from "../../components/table/BootstrapTable";
import RTBFTable from "../../components/table/RtbfTable";
import RTBFActionsTable from "../../components/table/RtbfActionsTable"
import { Sparklines, SparklinesLine } from "react-sparklines";
import {
    Row,
    Col,
    Card,
    Button,
    ButtonGroup,
    Dropdown,
    Accordion,
    DropdownButton,
    Table,
    Badge,
    Alert
} from "react-bootstrap";

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import PaymentTable from './Elements/PaymentTable';
import TopProducts from './Elements/TopProducts';
import ActivityTab from './Elements/ActivityTab';
import UserActivity from './Elements/UserActivity';


const AreaChart2Canvas = loadable(() =>
    pMinDelay(import("./Elements/AreaChart2Canvas"), 1000)
);
const ChartWidget2 = loadable(() =>
    pMinDelay(import("./Elements/ChartWidget2"), 1000)
);
const ShareProfitCanvas2 = loadable(() =>
    pMinDelay(import("./Elements/ShareProfitCanvas2"), 1000)
);
const ActiveUserCanvas = loadable(() =>
    pMinDelay(import("./Elements/ActiveUserCanvas"), 1000)
);

const sampleData = [6, 2, 8, 4, 3, 8, 4, 3, 6, 5, 9, 2,];

const DataClassificationDashboard = () => {
    const {
        changeBackground,
        changeSideBarStyle,
        chnageSidebarColor,
        changeNavigationHader
    } = useContext(ThemeContext);



    useEffect(() => {
        changeBackground({ value: "light", label: "Light" });
        changeSideBarStyle({ value: "mini", label: "Mini" });
        chnageSidebarColor("color_3");
        changeNavigationHader("color_3");

    }, []);
    return (
        <>
            <AllSection />
        </>
    )
}

function AllSection() {
    const [showEdmAlert, setShowEdmAlert] = useState(false);

    const handleEDMTeamConnect = () => {
        setShowEdmAlert(true);
    };

    const StaticTable = () => (
        <table>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>John Doe</td>
                    <td>johndoe@example.com</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Jane Doe</td>
                    <td>janedoe@example.com</td>
                </tr>
                {/* Add more rows as needed */}
            </tbody>
        </table>
    );

    return (

        <div>
            <div className='row pt-5'>
                <h1 className='title text-center'> Data Classification Dashboard</h1>
            </div>
            <div className='row card mt-5 pb-5'>

                <Card>
                    <Card.Header>
                        <Card.Title>Database Objects</Card.Title>
                    </Card.Header>

                </Card>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>OBJECT_TYPE</th>
                            <th>DATABASE</th>
                            <th>SCHEMA_NAME</th>
                            <th>TABLE_NAME</th>
                            <th>TABLE_OWNER</th>
                            <th>IS_MASKED_OBJECT</th>
                            <th>CREATED_ON_DATE</th>
                            <th>LAST_ALTERED_DATE</th>
                            <th>LAST_DATA_REFRESH</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <th>EVENT TABLE</th>
                            <td>EVENTS_DB</td>
                            <td>
                                <Badge bg="" className="badge-primary light">PUBLIC</Badge>
                            </td>
                            <td>EVENTS</td>
                            <td className="color-primary">ACCOUNTADMIN</td>
                            <td className="color-primary">FALSE</td>
                            <td className="color-primary">2023-07-06 12:53:04.553 -0700</td>
                            <td className="color-primary">2024-05-07 02:08:00.852 -0700</td>
                            <td className="color-primary">2024-05-07 07:32:46.616 -0700</td>
                        </tr>

                        <tr>
                            <th>VIEW</th>
                            <td>MART</td>
                            <td>
                                <Badge bg="" className="badge-primary light">API</Badge>
                            </td>
                            <td>CRMCUSTOMER_API</td>
                            <td className="color-primary">SNOWFLAKE_SVC_DBT_PII_PRD</td>
                            <td className="color-primary">TRUE</td>
                            <td className="color-primary">2024-05-07 01:40:26.471 -0700</td>
                            <td className="color-primary">2024-05-07 04:04:35.814 -0700</td>
                            <td className="color-primary">2024-05-07 07:32:46.616 -0700</td>
                        </tr>
                        <tr>
                            <th>BASE TABLE</th>
                            <td>MART</td>
                            <td>
                                <Badge bg="" className="badge-primary light">WIDE</Badge>
                            </td>
                            <td>CRMHOUSEHOLD_WIDE</td>
                            <td className="color-primary">SNOWFLAKE_SVC_DBT_PII_PRD</td>
                            <td className="color-primary">TRUE</td>
                            <td className="color-primary">2024-05-07 01:40:26.471 -0700</td>
                            <td className="color-primary">2024-05-07 04:04:35.814 -0700</td>
                            <td className="color-primary">2024-05-07 07:32:46.616 -0700</td>
                        </tr>

                    </tbody>
                </Table>
            </div>
            <div className='row card mt-5 pb-5'>

                <Card>
                    <Card.Header>
                        <Card.Title>Classification Results</Card.Title>
                    </Card.Header>

                </Card>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>OBJECT_NAME</th>
                            <th>DB_N</th>
                            <th>SC_N</th>
                            <th>TB_N</th>
                            <th>COLUMN_NAME</th>
                            <th>PRIVACY_CATEGORY</th>
                            <th>SEMANTIC_CATEGORY</th>
                            <th>TYPE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <th>DMT.ML.CANCELLATIONS</th>
                            <td>DMT</td>
                            <td>
                                <Badge bg="" className="badge-primary light">ML</Badge>
                            </td>
                            <td>CANCELLATIONS</td>
                            <td className="color-primary">DIVISION_CODE</td>
                            <td>null</td>
                            <td>null</td>
                            <td>primary</td>
                        </tr>
                        <tr>
                            <th>DMT.ML.CANCELLATIONS_BOOST</th>
                            <td>DMT</td>
                            <td>
                                <Badge bg="" className="badge-primary light">ML</Badge>
                            </td>
                            <td>CANCELLATIONS_BOOST</td>
                            <td className="color-primary">LOAN_TYPE</td>
                            <td>null</td>
                            <td>null</td>
                            <td>primary</td>
                        </tr>

                    </tbody>
                </Table>
            </div>
            <div>
                <Row className="justify-content-center">
                    <Col xs={12} md={3} style={{ paddingLeft: '0', display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ width: '100%', maxWidth: '350px' }} variant="light" onClick={handleEDMTeamConnect}>
                            Connect with EDM Team
                        </Button>
                    </Col>
                </Row>
                {showEdmAlert && (
                    <div style={{
                        position: 'fixed',
                        top: '50%',
                        left: '56%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1050,
                        width: '100%',
                        maxWidth: '600px'
                    }}>
                        <Alert variant="secondary" dismissible onClose={() => setShowEdmAlert(false)} className="solid">

                            <strong>Done! </strong> EDM team has been notified and will reach out to you via email shortly.
                            <button type="button" className="btn-close" onClick={() => setShowEdmAlert(false)}>
                                <span><i className="mdi mdi-close" /></span>
                            </button>
                        </Alert>
                    </div>
                )}
            </div>





        </div>

    )
}

export { AllSection };
export default DataClassificationDashboard;